// /home/ananun/fluorescence.pro/admin/src/helpers/ensureDraftOnAdd.js

/**
 * Checks if the current page is a brand-new temporary draft
 * (navigated from the "Add" button in the list page).
 *
 * ListPage.addNew creates a temporary object via POST and navigates to
 * /{route}/{_id}?temporary=true. This helper detects that flag so
 * components can skip fetching stale data and just use default state.
 *
 * @param {string} locationSearch - location.search from useLocation()
 * @returns {boolean} true when opening a newly created draft
 */
export function isDraftMode(locationSearch) {
	return new URLSearchParams(locationSearch).get("temporary") === "true";
}
